/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

export type Severity = 'CRITICAL' | 'SEVERE' | 'MODERATE' | 'LOW' | 'NONE';
export const SEVERITIES: Severity[] = ['CRITICAL', 'SEVERE', 'MODERATE', 'LOW', 'NONE'];

export type QuarantineSortField = 'QUARANTINE_TIME' | 'SEVERITY' | 'COMPONENT' | 'REPOSITORY' | 'POLICY';

export type FilterSection = 'severity' | 'policy' | 'ecosystem' | 'repository';
export type QuarantineFilters = Record<FilterSection, string[]>;

export interface QuarantineQuery {
  filters: QuarantineFilters;
  search: string;
  sortBy: QuarantineSortField;
  asc: boolean;
  /** 1-based, like the backend and TablePagination. */
  page: number;
  pageSize: number;
}

export interface QuarantinedComponent {
  /** Stable id for the future component detail link. */
  key: string;
  threatLevel: number;
  severity: Severity;
  ecosystem: string;
  displayName: string;
  coordinates: Record<string, string>;
  repositoryName: string;
  policyName: string;
  quarantineTime: string | null;
}

export interface FacetValue {
  value: string;
  count: number;
}

export type QuarantineFacets = Record<FilterSection, FacetValue[]>;

export interface QuarantinePage {
  total: number;
  page: number;
  pageSize: number;
  truncated: boolean;
  limit: number;
  results: QuarantinedComponent[];
  facets: QuarantineFacets;
}

export interface QuarantineSummary {
  activeCount: number;
  truncated: boolean;
  limit: number;
}

export const PAGE_SIZES = [25, 50, 100] as const;

export const EMPTY_FILTERS: QuarantineFilters = { severity: [], policy: [], ecosystem: [], repository: [] };

export const DEFAULT_QUERY: QuarantineQuery = {
  filters: EMPTY_FILTERS,
  search: '',
  sortBy: 'QUARANTINE_TIME',
  asc: false,
  page: 1,
  pageSize: PAGE_SIZES[0],
};
